<template>
	<a
		v-if="post.id"
		class="post-card"
		:class="post.sticky || post.falseSticky ? 'sticky' : ''"
		:href="post.link"
	>
		<div class="item-thumbnail" :style="'background-image:url('+ srcImage +')'">
			<span v-if="post.sticky" class="kook-btn-une">Article à la une</span>
		</div>
		<div class="item-content">
			<div class="container-date-category">
				<span class="date">{{date}}</span>
				<span class="category" v-html="post.categories_name"></span>
			</div>
			<span class="title" v-html="post.title_trimmed"></span>
			<div
				class="post-content"
			>{{post.sticky || post.falseSticky ? post.content_trimmed_long : post.content_trimmed}}</div>
			<KookBtn class="--angle-right" texte="Lire cette actualité" :isLink="false" />
		</div>
	</a>
</template>

<script>
import KookBtn from '@components/global/KookBtn';

import { EventBus } from '@core/event-bus';
/**
 * Composant permettant d'afficher le contenu d'un article
 *
 * @version 1.0.0
 */
export default {
	name: 'PostCard',
	props: {
		/**
		 * L'identifiant de l'article dont il faut afficher le contenu
		 */
		post: {
			type: Object,
		},
	},
	data() {
		return {
			srcImage: '',
			date: '',
		};
	},
	mounted() {
		this.post.acf.image_card
			? (this.srcImage = this.post.acf.image_card)
			: this.getDefaultImage();

		this.date = this.getFormatedDate(this.post.date);
	},
	methods: {
		getDefaultImage() {
			$api.getField('image_par_defaut', 'categories', this.post.categories[0]).then((res) => {
				this.srcImage = res.data.image_par_defaut
					? res.data.image_par_defaut
					: require('@img/img-default.jpg');
			});
		},
		getFormatedDate(strDate) {
			return new Date(strDate).toLocaleDateString('fr-FR', {
				day: 'numeric',
				month: 'long',
				year: 'numeric',
			});
		},
	},
	components: {
		KookBtn,
	},
};
</script>

<style lang="scss" scoped>
@import '~@scss/style.scss';

.post-card {
	position: relative;
	text-decoration: none;
	background-color: #fff;
	border-radius: 15px;
	order: 1;

	@media screen and (min-width: $break-tablet) {
		&.sticky {
			order: 0;
			grid-column: 2 span;
			display: flex;
			min-height: 390px;
			overflow: hidden;
			border-radius: 15px;

			.item-thumbnail {
				border-radius: 0;
				width: 50%;
				height: 100%;
			}

			.item-content {
				width: 50%;
				height: 100%;
			}

			.container-date-category {
				color: $mainColor;
			}

			.title {
				margin-top: 25px;
			}

			.post-content {
				font-size: 15px;
			}
		}

		&:not(.sticky) {
			.container-date-category {
				position: absolute;
				top: -20px;
				// passer au-dessus d'item-thumbnail
				z-index: 2;
				transform: translateY(-100%);
				color: white;
			}
		}
	}

	@media screen and (max-width: $break-tablet) {
		&.sticky {
			height: 520px;
		}
	}

	@media screen and (min-width: $break-tablet + 1) {
		&:hover {
			.title {
				color: $secondaryColor;
			}

			.kook-btn {
				left: 0;
				background-color: $secondaryColor;
				color: white;
			}
		}
	}

	.container-date-category {
		display: flex;
		flex-direction: column;
	}

	.item-thumbnail {
		position: relative;
		width: 100%;
		height: 225px;
		background-size: cover;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;

		@media screen and (max-width: 1660px) {
			height: 200px;
		}

		&::before {
			content: '';
			width: 100%;
			height: 160px;
			position: absolute;
			bottom: 0;
			left: 0;
			background-image: linear-gradient(to top, black 0%, transparent 100%);
			z-index: 1;
		}

		.container-info {
			position: absolute;
			display: flex;
			flex-direction: column;
			bottom: 20px;
			left: 50px;
			z-index: 2;
		}

		.date {
			color: white;
			font-size: 12px;
			line-height: 20px;
		}

		.category {
			color: white;
			font-size: 15px;
			line-height: 22px;
		}

		.kook-btn-une {
			display: flex;
			justify-content: center;
			align-items: center;
			position: absolute;
			top: 30px;
			left: 30px;
			width: 150px;
			height: 45px;
			border-radius: 30px;
			background-color: $secondaryColor;
			color: white;
		}
	}

	.item-content {
		position: relative;
		display: flex;
		flex-direction: column;
		height: 290px;
		padding: 40px 50px;
		padding-bottom: 20px;
		background-color: #fff;
		transition: all 0.3s ease-in-out;
		border-bottom-left-radius: 15px;
		border-bottom-right-radius: 15px;

		@media screen and (max-width: 1660px) {
			padding: 30px 30px;
		}
	}

	.title {
		font-size: 22px;
		font-weight: 600;
		line-height: 25px;
		color: $mainColor;
		transition: all 0.3s ease-in-out;

		@media screen and (max-width: 1660px) {
			font-size: 18px;
			line-height: 20px;
		}
	}

	.post-content {
		margin-top: 20px;
		font-size: 12px;
		line-height: 20px;
		color: $dark;
	}

	.kook-btn {
		position: relative;
		left: -25px;
		width: 205px;
		justify-content: flex-start;
		margin-top: 10px;
		background-color: transparent;
		color: #ccd2d9;

		@media screen and (max-width: $break-tablet) {
			left: 0;
			background-color: $secondaryColor;
			color: white;
		}

		&::after {
			right: 20px;
			font-size: 20px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/post/Post-card.vue